import React from 'react';
import { Layout } from 'antd';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import styles from './styles.module.less';
import WelcomeMessage from 'components/WelcomeMessage/WelcomeMessage';
import { Brand } from 'constants/brand';
import { useBrand } from 'modules/shared/brand/hooks/useBrand';
import useIsDesktop from 'utils/hooks/useIsDesktop';

const { Sider, Content } = Layout;

const SignUpLayout = ({ children }) => {
  const { brand } = useBrand();
  const isDesktop = useIsDesktop();

  return (
    <Layout className={styles.wrapper}>
      <Sider
        width="60%"
        className={clsx(styles.aside, {
          [styles.backgroundImageFM]: brand === Brand.FM,
          [styles.backgroundImageGP]: brand === Brand.GP,
        })}
      >
        <WelcomeMessage />
      </Sider>
      <Content
        className={clsx(styles.content, {
          [styles.backgroundImageFM]: brand === Brand.FM && !isDesktop,
          [styles.backgroundImageGP]: brand === Brand.GP && !isDesktop,
        })}
      >
        {children}
      </Content>
    </Layout>
  );
};

SignUpLayout.propTypes = {
  children: PropTypes.node,
};

export default SignUpLayout;
